export default [
  {
    path: '/ningxia',
    name: "nx",
    component: () => import('@/views/ningxia/start.vue'),
    children: [
      {
        path: 'videoflow',
        name: "nxVideoFlow",
        component: () => import('@/views/ningxia/videoflow.vue'),
        meta: {
          title: '宁夏移动用户专享'
        }
      },
      {
        path: 'cvideoflow',
        name: "nxCVideoFlow",
        component: () => import('@/views/ningxia/cvideoflow.vue'),
        meta: {
          title: '宁夏移动用户专享'
        }
      },
      {
        path: 'ccvideoflow',
        name: "nxCCVideoFlow",
        component: () => import('@/views/ningxia/ccvideoflow.vue'),
        meta: {
          title: '宁夏移动用户专享'
        }
      },
      {
        path: 'bvideoflow',
        name: "nxBVideoFlow",
        component: () => import('@/views/ningxia/bvideoflow.vue'),
        meta: {
          title: '宁夏移动用户专享'
        }
      },
      {
        path: 'confirmVideoflow',
        name: "nxVideoFlowConfirm",
        component: () => import('@/views/ningxia/confirmVideoflow.vue'),
        meta: {
          title: '宁夏移动用户专享'
        }
      },
      {
        path: 'success',
        name: "nxSuccess",
        component: () => import('@/views/ningxia/success.vue'),
        meta: {
          title: '办理成功'
        }
      }
    ]
  }
]